import { FunctionComponent } from 'react';
import './prices.scss';
import { LicenseType, moduleStructure } from './price-details';
import { FormatEuro } from './prices';
import B from '../shared/html-tags/b';
import { Check, CheckCircleOutline } from '@mui/icons-material';
export type Props = {
  module: moduleStructure;
  lic_type: LicenseType;
  selectedBundle: moduleStructure & { includedModules: string[] };
  selectedLicType: LicenseType;
  moduleSelected: boolean;
  showPrice: boolean;
};

const PricesSKU: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <>
      <div style={{ textAlign: 'center', lineHeight: '0.75' }}>
        {props.showPrice === true ? (
          <b
            style={
              props.lic_type === props.selectedLicType && props.moduleSelected
                ? { color: 'var(--PriceDekoColor)' }
                : undefined
            }
          >
            {FormatEuro(
              props.module.variations.find((x) => x.lic_type === props.lic_type)?.PS_Imago_Price ??
                0
            )}
          </b>
        ) : (
          <>
            <b
              style={{
                fontSize: '0.9rem',
                color:
                  props.moduleSelected && props.lic_type === props.selectedLicType
                    ? 'var(--PriceDekoColor)'
                    : '#dddddd',
              }}
            >
              <CheckCircleOutline />
            </b>
          </>
        )}

        <br />
        <i
          style={{
            fontSize: '0.6rem',
            lineHeight: '0.5',
            color:
              props.moduleSelected && props.lic_type === props.selectedLicType
                ? 'var(--PriceDekoColor)'
                : '#dddddd',
          }}
        >
          {props.module.variations.find((x) => x.lic_type === props.lic_type)?.sku}
        </i>
      </div>
    </>
  );

  /*
  return (
  <div style={{ textAlign: 'center', lineHeight: '1.15' }}>
      <b
        style={
          props.lic_type === props.selectedLicType && props.moduleSelected
            ? { color: 'crimson' }
            : undefined
        }
      ></b>

      <i style={{ fontSize: '0.9rem', lineHeight: '0.5' }}>
        <span
          style={
            props.lic_type === props.selectedLicType && props.moduleSelected
              ? { color: 'crimson', fontWeight: 'bold' }
              : undefined
          }
        >
          {props.module.variations.find((x) => x.lic_type === props.lic_type)?.sku}
        </span>
      </i>
    </div>  
  
   ============================================================================================
   Original:
   ============================================================================================
  <div style={{ textAlign: 'center', lineHeight: '1.15' }}>
      {!props.selectedBundle.includedModules.includes(props.module.name) ? (
        <b
          style={
            props.lic_type === props.selectedLicType && props.moduleSelected
              ? { color: 'crimson' }
              : undefined
          }
        >
          {FormatEuro(
            props.module.variations.find((x) => x.lic_type === props.lic_type)?.PS_Imago_Price ?? 0
          )}
        </b>
      ) : (
        <B language="de" style={{ fontSize: '0.7rem' }}>
          im Bundle enthalten
        </B>
      )}
      <br />
      <i style={{ fontSize: '0.7rem', lineHeight: '0.5' }}>
        {props.module.variations.find((x) => x.lic_type === props.lic_type)?.sku}
      </i>
    </div>
  );

  */
};

export default PricesSKU;
